<template >
  <div style="width: 1200px;">
      <div class="topMess">
      <div class="topLeft">
        <div class="time"><img src="/public/icons/时钟.png" > {{ jobTime }}更新</div>
        <div class="name"><h1>{{ job.jobName }}</h1><h3>{{ job.salary }}</h3></div>
        <div class="tags">
          <p>{{ job.address }}</p>
          <p>{{ job.type }}</p>
          <p v-for="item in job.tags">{{ item }}</p>
        </div>
      </div>
      <div class="topRight">
        <div class="btn" @click="applyJob">立即投递</div>
      </div>
    </div>
    <div class="mainBox">
      <el-card class="otherMess">
          <div class="ofOne">
            <div class="otherTitle">职位描述：</div>
            <div class="messages" v-html="formattedResponsibility"></div>
          </div>
          <div class="ofOne">
            <div class="otherTitle">岗位要求：</div>
            <div class="messages" v-html="formattedRequirements"></div>
          </div>
      </el-card>
      <el-card class="boxRight">
        <div class="companyLogo"><img :src="companyLogo" alt=""></div>
        <h3>{{ job.companyMessage?.companyName || '' }}</h3>
        <p>所属行业：{{ job.companyMessage?.companyIndustry || '' }}</p>
        <p>企业规模：{{ job.companyMessage?.staffNumber || '' }}</p>
        <div class="btns" @click="toCompany">查看企业详情</div>
        <div class="btns contact-btn" @click="contactCompany">联系企业</div>
      </el-card>
    </div>
  </div>
 
  <backTop/>
</template>
<script setup>
import backTop from '@/components/backTop.vue';
import { computed ,onMounted} from 'vue';
import { useRoute, useRouter } from 'vue-router';
const route = useRoute();
const router = useRouter();
import moment from 'moment';
import { reactive } from 'vue';
import axios from '../../util/axios.config';
import store from '@/store';
const job = reactive({
  _id: "",
  pubUser: "",
  jobName: "",
  salary: "",
  address: "",
  subject: [],
  jobKinds: [],
  type: "",
  tags: [],
  responsibility: "",
  requirements: "",
  companyMessage: {},
  editTime:  ""
})
const formattedResponsibility =computed(()=>{
   return (job.responsibility || '').replace(/\n/g, '<p style="margin-top : 10px"></p>');
}) 
const formattedRequirements =computed(()=>{
   return (job.requirements || '').replace(/\n/g, '<p style="margin-top : 10px"></p>');
})
const jobTime = computed(() => {
  return job.editTime ? moment(job.editTime).format('YYYY-MM-DD') : ''
})
const companyLogo = computed(()=>{
  const logo = job.companyMessage?.companyLogo || ''
  if (!logo) {
    return 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
  }
  // 支持 http/https 外链与后端相对路径
  if (/^https?:/i.test(logo)) return logo
  // 使用相对路径通过代理，避免混合内容问题
  return logo.includes("blob") ? logo : logo
})
onMounted(()=>{
  let getJob = null
  try{
    if (typeof route.query.job === 'string') {
      getJob = JSON.parse(route.query.job)
      localStorage.setItem('lastJob', route.query.job)
    } else {
      const cached = localStorage.getItem('lastJob')
      if (cached) getJob = JSON.parse(cached)
    }
  }catch(err){
    console.log('解析职位失败:', err)
  }
  if(getJob){
    Object.assign(job, getJob)
    store.commit('changeLastLook', job)
  }
})

// 立即投递
const applying = reactive({ loading: false })
async function applyJob(){
  if(applying.loading) return
  try{
    applying.loading = true
    await axios.post('/staffapi/jobs/apply',{
      jobId: job._id,
      pubUser: job.pubUser,
      companyUsername: (job.companyMessage && job.companyMessage.director) || job.pubUser,
      jobName: job.jobName
    })
    alert('投递成功！')
  }catch(err){
    console.log(err)
    alert('投递失败：' + (err?.response?.data?.msg || err.message || '未知错误'))
  }finally{
    applying.loading = false
  }
}

function toCompany(){
  const director = job.pubUser
  const companyObj = job.companyMessage || {}
  router.push({ path: '/company', query: { director, company: JSON.stringify(companyObj) } })
}

// 联系企业
async function contactCompany(){
  try {
    // 获取企业用户名
    const companyUsername = (job.companyMessage && job.companyMessage.director) || job.pubUser
    if (!companyUsername) {
      alert('无法获取企业信息，请联系管理员')
      return
    }
    
    // 跳转到聊天页面，传递企业用户名
    router.push({ 
      path: '/chat', 
      query: { companyUsername } 
    })
  } catch (err) {
    console.error('联系企业失败:', err)
    alert('联系企业失败：' + (err?.response?.data?.msg || err.message || '未知错误'))
  }
}
</script>
<style lang="scss" scoped>
.topMess{
  width: 97%;
  height: 135px;
  background-color: #fff;
  padding: 20px;
  display: flex;
  .topLeft{
    width: 70%;
    height: 135px;
  }
  .topRight{
    width: 30%;
    height: 135px;
  }
}
.time{
  height: 30px;
  line-height: 30px;
  display: flex;
  img{
    width: 30px;
    margin-right: 10px;
  }
}
.name{
  width: 80%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  h3{
    color: rgba(0, 0, 255, 0.653);
  }
}
.tags{
  display: flex;
  margin-top: 20px;
  color: rgb(107, 105, 105);
  p{
    padding:0 15px;
    border-right: 1px solid black;
  }
  p:last-child{
    border-right: none;
  }
}
.btn{
  width: 170px;
  height: 50px;
  margin-top: 80px;
  margin-left: 40px;
  line-height: 50px;
  font-size: 20px;
  text-align: center;
  background-color: #007fff;
  color: #fff;
  border-radius: 25px;
  cursor: pointer;
}
.btn:hover{
  background-color: #3682ce;
}
.mainBox{
  width: 100%;
  display: flex;
  margin-top: 20px;
  margin-bottom: 30px;
}
.otherMess{
  width: 65%;
  margin-left: 3%;
  background-color: #fff;
  border-radius: 25px;
  padding: 25px;

}
.ofOne{
  margin-bottom: 20px;
}
.otherTitle{
  margin-bottom: 20px;
  font-size: 20px;
}
.messages{
  width: 100%;
}
.boxRight{
  width: 25%;
  margin-left: 2%;
  height: fit-content;
  border-radius: 25px;
  background-color: #fff;
  padding: 20px;
  .companyLogo{
    width: 100px;
    height: 100px;
    border-radius: 15px;
    overflow: hidden;
    margin-bottom: 20px;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  p{
    margin-top: 10px;
  }
  .btns{
    width: 100px;
    color: #007fff;
    border: #007fff 1px solid;
    padding: 8px 50px;
    border-radius: 35px;
    margin-top: 20px;
    margin-left: 50px;
    cursor: pointer;
    text-align: center;
    transition: all 0.3s;
  }
  .btns:hover{
    background-color: #007fff;
    color: #fff;
  }
  .contact-btn{
    background-color: #007fff;
    color: #fff;
    border: none;
  }
  .contact-btn:hover{
    background-color: #3682ce;
  }
}
</style>